<template>
    <v-card elevation="0">
        <v-card-text>
            <v-form>
                <v-card elevation="0">
                    <v-row no-gutters>
                        <v-col cols="12" md="3" class="px-2">
                            <v-select
                                prepend-icon="mdi-signal-variant"
                                clearable
                                chips
                                hide-selected
                                :items="opciones.tarifas.operator"
                                item-text="human"
                                item-value="encoded"
                                v-model="form.contractIsp"
                                label="Operador"
                            >
                                <template #selection="{ item }">
                                    <v-chip color="primary" class="white--text">
                                        {{ item.encoded }}
                                    </v-chip>
                                </template>
                            </v-select>
                        </v-col>
                        <v-col cols="12" md="3" class="px-2">
                            <v-select
                                prepend-icon="mdi-eye-off"
                                clearable
                                chips
                                hide-selected
                                :items="[
                                    { encoded: true, human: 'Activos' },
                                    { encoded: false, human: 'Inactivos' },
                                ]"
                                item-text="human"
                                item-value="encoded"
                                v-model="form.estadoServicio"
                                label="Activo/Inactivo"
                            >
                                <template #selection="{ item }">
                                    <v-chip color="primary" class="white--text">
                                        {{ item.human }}
                                    </v-chip>
                                </template>
                            </v-select>
                        </v-col>
                        <v-col cols="12" md="3" class="px-2">
                            <v-select
                                prepend-icon="mdi-video-input-component"
                                clearable
                                hide-selected
                                chips
                                :items="opciones.tarifas.segment"
                                item-text="human"
                                item-value="encoded"
                                v-model="form.contractSegment"
                                label="Segmento"
                            >
                                <template #selection="{ item }">
                                    <v-chip
                                        color="yellow darken-2"
                                        class="white--text"
                                    >
                                        <v-icon> mdi-call-merge </v-icon>
                                        {{ item.human }}
                                    </v-chip>
                                </template>
                            </v-select>
                        </v-col>
                        <v-col cols="12" md="3" class="px-2">
                            <v-select
                                prepend-icon="mdi-palette-swatch"
                                clearable
                                hide-selected
                                chips
                                :items="families"
                                item-text="human"
                                item-value="encoded"
                                v-model="form.contractTariffCategory"
                                label="Familia"
                                hint="Este filtro afecta directamente a los resultados, no es solamente para filtrar los servicios"
                            >
                                <template #selection="{ item }">
                                    <v-chip color="purple" class="white--text">
                                        {{ item.human }}
                                    </v-chip>
                                </template>
                            </v-select>
                        </v-col>
                    </v-row>
                </v-card>
                <v-card elevation="0" class="px-2 mt-2">
                    <v-row no-gutters>
                        <v-col cols="12" md="3" class="px-2">
                            <v-select
                                :hint="
                                    selectedServiceType
                                        ? 'Elimine la selección para visualizar todos los elementos elegidos a la derecha'
                                        : ''
                                "
                                prepend-icon="mdi-shape"
                                clearable
                                hide-selected
                                chips
                                v-model="selectedServiceType"
                                :items="serviceType"
                                item-text="human"
                                item-value="encoded"
                                label="Tipo de Servicio"
                            >
                                <template #selection="{ item }">
                                    <v-chip color="pink" class="white--text">
                                        <v-icon> mdi-call-merge </v-icon>
                                        {{ item.human }}
                                    </v-chip>
                                </template>
                            </v-select>
                        </v-col>
                        <v-col cols="12" md="9" class="px-2">
                            <v-autocomplete
                                prepend-icon="mdi-format-list-bulleted-type"
                                clearable
                                @click:clear="clearform()"
                                multiple
                                chips
                                v-model="mixedTariffs"
                                :items="availableTariffsDropDown"
                                persistent-hint
                                :hint="hintText"
                                item-text="name"
                                item-value="id"
                                :no-data-text="
                                    tariffsDropDown.length == 0
                                        ? 'No hay tarifas disponibles'
                                        : 'No hay elementos que coincidan'
                                "
                                label="Servicios"
                            >
                                <template #selection="{ item }">
                                    <v-chip
                                        @click:close="remove(item)"
                                        close
                                        :color="
                                            isOnContained(item)
                                                ? 'success'
                                                : 'error'
                                        "
                                        class="mt-1 white--text"
                                    >
                                        <v-icon> mdi-credit-card </v-icon>
                                        {{ item.name ? item.name : item.id }}
                                    </v-chip>
                                </template>
                                <template #item="{ item }">
                                    <v-list-item
                                        :v-on="openSelector()"
                                        :style="
                                            $vuetify.breakpoint.smAndDown
                                                ? item.is_active
                                                    ? 'background-color: #c5f9c2;'
                                                    : 'background-color: #fcc4c4;'
                                                : ''
                                        "
                                    >
                                        <v-row
                                            v-if="
                                                !$vuetify.breakpoint.smAndDown
                                            "
                                        >
                                            <v-col
                                                md="5"
                                                class="d-flex justify-start"
                                            >
                                                <v-icon
                                                    class="mr-2"
                                                    :color="
                                                        item.is_active
                                                            ? 'success'
                                                            : 'error'
                                                    "
                                                >
                                                    mdi-circle
                                                </v-icon>
                                                {{
                                                    item && item.name
                                                        ? item.name
                                                        : item.id
                                                }}
                                            </v-col>
                                            <v-col
                                                v-if="
                                                    !$vuetify.breakpoint
                                                        .smAndDown
                                                "
                                                cols="1"
                                            >
                                                {{
                                                    item.type == 'TARIFF'
                                                        ? 'TARIFA'
                                                        : item.type
                                                }}
                                            </v-col>
                                            <v-col cols="2">
                                                {{ item.segment }}
                                            </v-col>
                                            <v-col
                                                cols="3"
                                                class="d-flex justify-center"
                                            >
                                                {{ item.operator }}
                                            </v-col>
                                            <v-col cols="1" class="d-flex">
                                                <v-btn
                                                    class="ml-n5"
                                                    :outlined="
                                                        isOnContained(item)
                                                    "
                                                    small
                                                    icon
                                                    color="success"
                                                    @click.stop="
                                                        addContainedTariffs(
                                                            item
                                                        )
                                                    "
                                                >
                                                    <v-icon size="18">
                                                        mdi-check
                                                    </v-icon>
                                                </v-btn>
                                                <v-btn
                                                    :outlined="
                                                        isOnNotContained(item)
                                                    "
                                                    class="ml-3"
                                                    small
                                                    icon
                                                    color="error"
                                                    @click.stop="
                                                        addNotContainedTariffs(
                                                            item
                                                        )
                                                    "
                                                >
                                                    <v-icon size="18">
                                                        mdi-close
                                                    </v-icon>
                                                </v-btn>
                                            </v-col>
                                        </v-row>
                                        <v-row v-else>
                                            <v-col
                                                cols="1"
                                                class="
                                                    d-flex
                                                    justify-start
                                                    pa-0
                                                    align-center
                                                "
                                            >
                                                <v-btn
                                                    :outlined="
                                                        isOnContained(item)
                                                    "
                                                    small
                                                    icon
                                                    color="success"
                                                    @click.stop="
                                                        addContainedTariffs(
                                                            item
                                                        )
                                                    "
                                                >
                                                    <v-icon size="18">
                                                        mdi-check
                                                    </v-icon>
                                                </v-btn>
                                            </v-col>
                                            <v-col cols="10">
                                                {{
                                                    item && item.name
                                                        ? item.name
                                                        : item.id
                                                }}
                                            </v-col>
                                            <v-col
                                                cols="1"
                                                class="
                                                    d-flex
                                                    justify-start
                                                    pa-0
                                                    align-center
                                                "
                                            >
                                                <v-btn
                                                    :outlined="
                                                        isOnNotContained(item)
                                                    "
                                                    small
                                                    icon
                                                    color="error"
                                                    @click.stop="
                                                        addNotContainedTariffs(
                                                            item
                                                        )
                                                    "
                                                >
                                                    <v-icon size="18">
                                                        mdi-close
                                                    </v-icon>
                                                </v-btn>
                                            </v-col>
                                        </v-row>
                                    </v-list-item>
                                </template>
                            </v-autocomplete>
                        </v-col>
                    </v-row>
                </v-card>
                <v-card elevation="0" class="px-2 mt-2">
                    <v-row no-gutters>
                        <v-col cols="12" md="3" class="px-2 mb-n2">
                            <v-menu
                                v-model="menu"
                                :close-on-content-click="false"
                                :nudge-right="40"
                                transition="scale-transition"
                                offset-y
                                min-width="auto"
                            >
                                <template v-slot:activator="{ on, attrs }">
                                    <v-text-field
                                        clearable
                                        v-model="contractPermanenceEnding"
                                        label="Fecha permanencia"
                                        prepend-icon="mdi-calendar"
                                        readonly
                                        v-bind="attrs"
                                        v-on="on"
                                        :disabled="menu === 0 ? true : false"
                                    >
                                        <template v-slot:prepend>
                                            <v-btn-toggle
                                                class="pa-0"
                                                style="
                                                    margin-top: -0px;
                                                    margin-left: 0px;
                                                "
                                                v-model="menu"
                                                borderless
                                            >
                                                <v-btn class="pa-0" small icon>
                                                    <v-icon>
                                                        {{
                                                            menu === 0
                                                                ? 'mdi-calendar-remove'
                                                                : 'mdi-calendar'
                                                        }}
                                                    </v-icon>
                                                </v-btn>
                                            </v-btn-toggle>
                                        </template>
                                    </v-text-field>
                                </template>
                                <v-date-picker
                                    range
                                    v-model="fechaPermanencePicker"
                                    locale="es-419"
                                    :first-day-of-week="1"
                                ></v-date-picker>
                            </v-menu>
                        </v-col>
                        <v-col cols="12" md="3" class="d-flex px-2 mb-n2">
                            <v-icon left>mdi-chevron-triple-up</v-icon>
                            <v-select
                                v-model="form.contractServiceState"
                                clearable
                                hide-selected
                                chips
                                :items="serviceStates"
                                label="Estado del Servicio"
                            >
                                <template #selection="{ item }">
                                    <v-chip
                                        color="teal accent-3"
                                        class="white--text"
                                    >
                                        <v-icon> mdi-call-merge </v-icon>
                                        {{ item }}
                                    </v-chip>
                                </template>
                            </v-select>
                        </v-col>
                        <v-col cols="12" md="3" class="d-flex px-2 mb-n2">
                            <v-icon left>mdi-identifier</v-icon>
                            <v-text-field
                                style="margin-top: 13.7px"
                                v-model="form.contractSfid"
                                label="SFID"
                                persistent-hint
                            ></v-text-field>
                        </v-col>
                        <v-col cols="12" md="3" class="d-flex px-2 mb-n2">
                            <v-icon left>mdi-identifier</v-icon>
                            <v-text-field
                                style="margin-top: 13.7px"
                                v-model="form.contractPackageId"
                                label="ID de Orden en Frontal"
                                type="number"
                                persistent-hint
                            ></v-text-field>
                        </v-col>
                    </v-row>
                </v-card>
            </v-form>
        </v-card-text>
    </v-card>
</template>

<script>
import { mapState } from 'vuex';

export default {
    name: 'ContractDataFilters',
    data: () => ({
        menu: false,
        lastContractPermenceEnding: [],
        selectedServiceType: null,

        mixedTariffs: [],

        serviceStates: ['ACTIVO', 'VUELO', 'CANCELADO'],
        families: [
            {
                human: 'Convergente',
                encoded: 'convergent',
            },
            {
                human: 'Móvil',
                encoded: 'mobile_line',
            },
            {
                human: 'Fijo',
                encoded: 'fixed_line',
            },
        ],
        serviceType: [
            {
                human: 'Tarifas',
                encoded: 'TARIFF',
            },
            {
                human: 'SVAS',
                encoded: 'SVA',
            },
            {
                human: 'Adicionales',
                encoded: 'ADITIONAL',
            },
        ],
    }),
    computed: {
        fecha_Permanence_isNull() {
            return this.menu;
        },
        fechaPermanencePicker: {
            get: function () {
                if (this.form.contractPermanenceEnding === 'null') return [];
                return this.form.contractPermanenceEnding;
            },
            set(val) {
                this.contractPermanenceEnding = val;
            },
        },
        contractPermanenceEnding: {
            get: function () {
                if (this.menu === 0) return 'Sin fecha de permanencia';

                if (
                    !this.form.contractPermanenceEnding[0] ||
                    this.form.contractPermanenceEnding === 'null'
                )
                    return '';
                const [year, month, day] =
                    this.form.contractPermanenceEnding[0].split('-');
                if (!this.form.contractPermanenceEnding[1])
                    return `${day}/${month}/${year}`;

                const [year2, month2, day2] =
                    this.form.contractPermanenceEnding[1].split('-');
                return (
                    `${day}/${month}/${year}` +
                    ' ~ ' +
                    `${day2}/${month2}/${year2}`
                );
            },
            set: function (val) {
                if (!val) {
                    val = [];
                }
                this.form.contractPermanenceEnding = val;
            },
        },
        hintText() {
            let humanTxt = this.serviceType.find(
                (item) => item.encoded == this.selectedServiceType
            );
            let numItems = this.availableTariffsDropDown.length.toString();

            let base = humanTxt
                ? `${numItems} ${humanTxt.human}`
                : `${numItems} servicios`;

            let estadoServicio =
                this.form.estadoServicio != null
                    ? ` ${this.form.estadoServicio ? 'activos' : 'inactivos'} `
                    : '';

            let operatorFilter = this.form.contractIsp
                ? ` de ${this.form.contractIsp} `
                : '';
            let segmentFilter = this.form.contractSegment
                ? `${this.form.contractSegment.toLowerCase()}`
                : '';

            return (
                base +
                estadoServicio +
                operatorFilter +
                segmentFilter +
                ' disponibles'
            );
        },
        availableTariffsDropDown() {
            let filterIs_active = (item) =>
                this.form.estadoServicio != null
                    ? item.is_active == this.form.estadoServicio
                    : true;

            let filterCategory = (item) =>
                this.form.contractTariffCategory
                    ? item.category == this.form.contractTariffCategory
                    : true;

            let filterOperator = (item) =>
                this.form.contractIsp
                    ? item.operator == this.form.contractIsp
                    : true;
            let filterSegment = (item) =>
                this.form.contractSegment
                    ? item.segment == this.form.contractSegment
                    : true;
            let filterType = (item) =>
                this.selectedServiceType
                    ? item.type == this.selectedServiceType
                    : true;

            return this.tariffsDropDown.filter(
                (item) =>
                    filterIs_active(item) &&
                    filterType(item) &&
                    filterOperator(item) &&
                    filterSegment(item) &&
                    filterCategory(item)
            );
        },
        form: {
            get: function () {
                return this.$store.state.teletrabajo.QueryForm;
            },
            set: function (val) {
                this.$store.commit('teletrabajo/QueryForm', val);
            },
        },
        opciones() {
            return JSON.parse(localStorage.getItem('opciones'));
        },
        ...mapState('ManagementBase/promotionManagement', {
            tariffsDropDown: (state) => state.tariffsDropDown,
        }),
    },
    methods: {
        openSelector() {
            if (document.querySelector('.v-menu__content'))
                document.querySelector('.v-menu__content').firstChild.style =
                    'padding: 0px;';
        },
        orderDates(arr) {
            let date_from = new Date(arr[0]);
            let date_to = new Date(arr[1]);
            if (date_from > date_to) {
                let c = arr[0];
                arr[0] = arr[1];
                arr[1] = c;
            }
            return arr;
        },
        async clearform() {
            this.form.contractServices = [];
            this.form.notContractServices = [];
            this.mixedTariffs = [];
            this.form.contractPermanenceEnding = [];
            this.menu = false;
        },
        isOnMixed(item) {
            return this.mixedTariffs.some((element) => element == item.id);
        },
        isOnContained(item) {
            return this.form.contractServices.some(
                (element) => element == item.id
            );
        },
        isOnNotContained(item) {
            return this.form.notContractServices.some(
                (element) => element == item.id
            );
        },
        addContainedTariffs(item) {
            let notContainedIndex = this.form.notContractServices.indexOf(
                item.id
            );
            let containedIndex = this.form.contractServices.indexOf(item.id);

            if (notContainedIndex != -1)
                this.form.notContractServices.splice(notContainedIndex, 1);
            if (containedIndex == -1) this.form.contractServices.push(item.id);

            this.mixedTariffs = [
                ...this.form.contractServices,
                ...this.form.notContractServices,
            ];
        },
        addNotContainedTariffs(item) {
            let containedIndex = this.form.contractServices.indexOf(item.id);
            let notContainedIndex = this.form.notContractServices.indexOf(
                item.id
            );

            if (containedIndex != -1)
                this.form.contractServices.splice(containedIndex, 1);
            if (notContainedIndex == -1)
                this.form.notContractServices.push(item.id);

            this.mixedTariffs = [
                ...this.form.contractServices,
                ...this.form.notContractServices,
            ];
        },
        setThisMonth() {
            let date = new Date(),
                y = date.getFullYear(),
                m = date.getMonth();
            let firstDay = new Date(y, m, 1).toISOString().split('T')[0];
            let lastDay = new Date(y, m + 1, 0).toISOString().split('T')[0];

            this.contractPermanenceEnding = [];
            this.contractPermanenceEnding.push(lastDay);
            this.contractPermanenceEnding.push(firstDay);
        },
        remove(item) {
            let index = this.mixedTariffs.indexOf(item.id);
            this.mixedTariffs.splice(index, 1);
        },
    },
    watch: {
        fecha_Permanence_isNull() {
            if (this.menu == 0) {
                this.lastContractPermenceEnding =
                    this.form.contractPermanenceEnding;
                this.form.contractPermanenceEnding = 'null';
            } else {
                this.form.contractPermanenceEnding =
                    this.lastContractPermenceEnding;
            }
        },
        form: {
            deep: true,
            immediate: true,
            // Si la primera fecha es mayor que la segunda reordenamos
            handler: function () {
                if (this.form.contractPermanenceEnding[1]) {
                    this.form.contractPermanenceEnding = this.orderDates(
                        this.form.contractPermanenceEnding
                    );
                }
            },
        },
    },
    updated() {
        let filters = 0;
        let fields = [
            'contractIsp',
            'estadoServicio',
            'contractSegment',
            'contractTariffCategory',
            'contractPermanenceEnding',
            'contractServiceState',
            'contractPackageId',
        ];

        Object.keys(this.form).forEach((field) => {
            if (
                fields.includes(field) &&
                this.form[field] &&
                this.form[field]?.length
            )
                filters += 1;
        });

        if (this.mixedTariffs.length) filters += 1;

        this.$root.$emit('contractFilters', filters);
    },

    mounted() {
        this.$root.$on('deleteTableFilters', () => {
            this.clearform();
        });
    },
};
</script>